/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Inbounds_To_CheckInputs */

const en_queue_inbounds_to_check = /** @type {(inputs: Queue_Inbounds_To_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbounds to check`)
};

/**
* | output |
* | --- |
* | "Inbounds to check" |
*
* @param {Queue_Inbounds_To_CheckInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_inbounds_to_check = /** @type {((inputs?: Queue_Inbounds_To_CheckInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Inbounds_To_CheckInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_inbounds_to_check(inputs)
});